import { useCallback, useEffect, useState } from 'react';
import { useParams, generatePath, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Map } from 'immutable';

import { paymentsGridGetTotalByStateAction, paymentsGridClearTotalByStateAction } from 'domain/payments';

import Api from 'domain/api';

import ROUTES_PATH from 'domain/router/routesPathConfig';

import { getNestedCategory } from 'domain/categories/helpers';

import useQuery from 'hooks/useQuery';

const useFetchTotalByCategory = () => {
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const navigate = useNavigate();
  const params = useParams();
  const query = useQuery();
  const category = getNestedCategory(params);
  const { category1 } = params;

  const [total, setTotal] = useState(null);
  const [isBusy, setIsBusy] = useState(true);
  const [totalIsFetched, setTotalIsFetched] = useState(false);

  const fetchGridTotal = useCallback(async () => {
    setIsBusy(true);
    try {
      if (category) {
        const { data } = await Api.getPaymentsGridTotalByCategory({
          params: {
            category,
            ...query,
          },
        });

        setTotal(data);
        setTotalIsFetched(true);
        dispatch(paymentsGridClearTotalByStateAction());
      } else {
        const { data } = await Api.getPaymentsGridTotalByState({
          params: {
            ...query,
          },
        });

        dispatch(paymentsGridGetTotalByStateAction(Map(data?.counters)));

        setTotal(data?.counters?.[query.flowState as string] ?? null);
        setTotalIsFetched(true);
      }
    } finally {
      setIsBusy(false);
    }
  }, [category, query, dispatch]);

  useEffect(() => {
    fetchGridTotal().then();
  }, [fetchGridTotal]);

  useEffect(() => {
    if (total === 0 && category !== category1) {
      const route = ROUTES_PATH.PAY_COMPANY.absolute;

      const path = generatePath(route, { companyId, category1 });

      navigate(path);
    }
  }, [total, navigate, category, category1, companyId]);

  return {
    paymentsTotal: total,
    paymentsTotalIsBusy: isBusy,
    paymentsTotalIsFetched: totalIsFetched,
    fetchGridTotal,
  };
};

export default useFetchTotalByCategory;
